/*
* @parameter {Array<Dish>} dishesInThisCategory: The flat array of all the dishes in this category, sorted by `pos`.
* @returns { key: String, value: Dish }:    The hash table whose keys are the dishes in this category, from the array above, 
*                                           and whose values are the corresponding dishes 
*/
export const dishesInCategoryToHashTable = (dishesInThisCategory) => {
    if (!dishesInThisCategory) {
      return {}
    } else {
      const dishIDToObjectMapper = {}
      
      dishesInThisCategory.forEach((dish) => {
        dishIDToObjectMapper[dish.itemKey] = dish
      })

      return dishIDToObjectMapper
  }
}